//import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleOAuthProvider } from "@react-oauth/google"
import './index.css';
// CSS de react-toastify GLOBAL: antes venía implícito porque las pantallas de auth (que lo
// importaban) eran eager. Al hacerlas lazy (code-splitting), su CSS pasó a chunks lazy y los
// toasts quedaban sin estilo (ícono gigante) en páginas que no cargan esas pantallas.
import 'react-toastify/dist/ReactToastify.css';

const rootEl = document.getElementById('root')!;

// El árbol de providers debe ser IDÉNTICO al del server (entry-server.tsx) para que la
// hidratación coincida (useId, etc.). Único cambio: BrowserRouter en el cliente vs
// StaticRouter en el server.
const app = (
  <GoogleOAuthProvider clientId='807258921721-eik1brork7ac1iuukkn8k2dub18b97nv.apps.googleusercontent.com'>
    <HelmetProvider>
      <BrowserRouter future={{ v7_relativeSplatPath: true }}>
        {/*<StrictMode>*/}
          <App />
        {/*</StrictMode>*/}
      </BrowserRouter>
    </HelmetProvider>
  </GoogleOAuthProvider>
);

// Hidratar SOLO en la home real: dist/index.html (con data-hydrate) es además el
// fallback SPA que Netlify sirve para rutas de app sin archivo prerenderizado
// (/user/*, /lawyer/*, etc.). En esos casos el pathname NO es '/', así que usamos
// createRoot (evita intentar hidratar HTML de home en otra ruta → mismatch).
if (rootEl.dataset.hydrate === '1' && window.location.pathname === '/') {
  hydrateRoot(rootEl, app);
} else {
  createRoot(rootEl).render(app);
}
